<template>

  <el-main
    class="main_content_detail"
    style="padding: 20px"
  >
    <div class="cont_navs_header1222">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>
          <a @click="jumpTo('/orderList')">订单管理</a>
        </el-breadcrumb-item>
        <el-breadcrumb-item>
          <a>订单详情</a>
        </el-breadcrumb-item>
      </el-breadcrumb>

      <!-- <div style="width:100px">
        <el-button type="text" icon="el-icon-printer">打印</el-button>
      </div> -->
    </div>

    <div class="contain_div2222">

      <div class="contain_header clr">
        <div class="userInfooi">
          <div class="moreUserInfo11">
            <div class="base_label">基本信息</div>
            <ul>
              <li>
                <font class="colorC fontWidth">订单号：</font>{{orderDetail.order_code}}
              </li>
              <li>
                <font class="colorC fontWidth">代理姓名：</font>{{orderDetail.t_name}}
              </li>

              <li>
                <font class="colorC fontWidth">代理手机号：</font>{{orderDetail.t_tel}}
              </li>
              <li>
                <font class="colorC fontWidth">订单类型：</font>{{orderDetail.typeV}}{{orderDetail.freeIn}}
              </li>
              <li>
                <font class="colorC fontWidth">订单总金额：</font>{{orderDetail.total_money}}
              </li>
              <li>
                <font class="colorC fontWidth">下单时间：</font>{{orderDetail.r_create_time}}
              </li>
              <br/>
              <li v-show="orderDetail.merger_short_name != null && orderDetail.role_type != 5.1 && orderDetail.role_type != 6">
                <font class="colorC fontWidth">所属区域：</font>{{orderDetail.merger_short_name}},负责人：{{orderDetail.area_m}}({{orderDetail.area_tel}})
              </li>


              <li style="width:100%">
                <font class="colorC fontWidth">订单备注：</font>{{orderDetail.order_info}}
              </li>

              <li
                style="width:50%"
                v-if="orderDetail.typeV == '自己提货发货'"
              >
                <font class="colorC fontWidth">地址：</font>{{orderDetail.province}}{{orderDetail.city}}{{orderDetail.district}}-{{orderDetail.address_detail}}:{{orderDetail.username}}({{orderDetail.telephone}})
              </li>

              <li
                style="width:20%"
                v-if="orderDetail.typeV == '自己提货发货'"
              >
                <font class="colorC fontWidth">物流号：</font>{{orderDetail.postage_code}}
              </li>


            </ul>
          </div>

          <!-- <div class="moreUserInfo11">
            <div class="base_label">资金信息</div>
            <ul>
              <li>
                <font class="colorC fontWidth">里：</font>1333
              </li>

              <li>
                <font class="colorC fontWidth">红包余额：</font>1333
              </li>
              <li>
                <font class="colorC fontWidth">保证金：</font>1333
              </li>

            </ul>
          </div> -->
        </div>
      </div>

      <div class="contain_body_head" v-if="orderDetail.subPackage.length > 0">
        已发货列表
      </div>
      <div v-for="(item,index) in orderDetail.subPackage" :index="index" v-if="orderDetail.subPackage.length > 0">
        <el-card style="margin-top: 10px" shadow="never">
          <div>物流单号：{{item.postageCode}}</div>
          <div>代理人：{{item.username}}</div>
          <div>发货人：{{item.sendUsername}}</div>
        </el-card>
        <el-table show-summary
          v-loading="subListLoading"
          :data="item.sendGoodList"
          style="width: 100%"
          :header-cell-class-name='objectSpanMethod'
        >
          <el-table-column
            prop="goodMsg"
            label="商品名称"
          >
            <template slot-scope="scope">
              {{scope.row.goodMsg.good_name}}
            </template>
          </el-table-column>
          <el-table-column
            prop="goodMsg"
            label="商品价格"
          >
            <template slot-scope="scope">
              {{scope.row.goodMsg.proxy_price}}
            </template>
          </el-table-column>
          <el-table-column
            prop="num"
            label="数量"
          >
          </el-table-column>

          <!-- <el-table-column label="商品图片">
            <template slot-scope="scope">
              <img
                :src="scope.row.list_pic"
                style="width:50px;"
              >
            </template>
          </el-table-column> -->

        </el-table>
      </div>
      <div style="height:10px;width:10px"></div>
      <div class="contain_body_head" v-if="orderDetail.subPackage.length > 0">
        未发货列表
      </div>
      <div v-if="orderDetail.subPackage.length > 0">
        <el-table show-summary
          v-loading="subListLoading"
          :data="orderDetail.subPackage[0].noSendGoodList"
          style="width: 100%"
          :header-cell-class-name='objectSpanMethod'
        >
          <el-table-column
            prop="goodMsg"
            label="商品名称"
          >
            <template slot-scope="scope">
              {{scope.row.goodMsg.good_name}}
            </template>
          </el-table-column>
          <el-table-column
            prop="goodMsg"
            label="商品价格"
          >
            <template slot-scope="scope">
              {{scope.row.goodMsg.proxy_price}}
            </template>
          </el-table-column>
          <el-table-column
            prop="num"
            label="数量"
          >
          </el-table-column>

          <!-- <el-table-column label="商品图片">
            <template slot-scope="scope">
              <img
                :src="scope.row.list_pic"
                style="width:50px;"
              >
            </template>
          </el-table-column> -->

        </el-table>
      </div>
      <div style="height:10px;width:10px"></div>

      <div class="contain_body_head" v-if="orderDetail.subPackage.length == 0">
        商品列表
      </div>
      <el-table show-summary
        v-loading="subListLoading"
        :data="subList"
        style="width: 100%"
        :header-cell-class-name='objectSpanMethod'
        v-if="orderDetail.subPackage.length == 0"
      >

        <el-table-column
          prop="good_name"
          label="商品名称"
        >
        </el-table-column>

        <el-table-column label="商品图片">
          <template slot-scope="scope">
            <img
              :src="scope.row.list_pic"
              style="width:50px;"
            >
          </template>
        </el-table-column>
        <el-table-column
          prop="good_price"
          label="原价"
        >
        </el-table-column>

        <el-table-column
          prop="proxy_price"
          label="代理价"
        >
        </el-table-column>

        <el-table-column
          prop="num"
          label="购买数量"
        >
        </el-table-column>

        <!-- <el-table-column
              prop="send_score"
              label="发货赠送积分"
            >
            </el-table-column> -->

            <el-table-column
              v-if="orderDetail.order_type == 1"
              prop="s_new_buy_num"
              label="发货赠送数量"
            >
            </el-table-column>
      </el-table>
      <div style="height:10px;width:10px"></div>
      <div
        class="contain_body_head"
        v-show="buList.length > 0"
      >
        补货商品列表
      </div>
      <div v-show="buList.length > 0">

        <div
          v-for="item in buList"
          v-bind:key='item.id'
        >
          <div class="contain_body_head">
            {{item.t_name}}({{item.t_tel}}),{{item.order_code}},下级购买金额：{{item.initM}}元，
            {{item.t_name}}购买总金额：{{item.order_money}}元,
            {{orderDetail.t_name}}购买总金额：{{item.total_money}}元
          </div>
          <el-table show-summary
            v-loading="subListLoading"
            :data="item.sub"
            style="width: 100%"
            :header-cell-class-name='objectSpanMethod'
          >

            <el-table-column
              prop="good_name"
              label="商品名称"
            >
            </el-table-column>

            <el-table-column label="商品图片">
              <template slot-scope="scope">
                <img
                  :src="scope.row.list_pic"
                  style="width:50px;"
                >
              </template>
            </el-table-column>
            <el-table-column
              prop="good_price"
              label="原价"
            >
            </el-table-column>

            <el-table-column
              prop="down_price"
              label="下级购买价格"
            >
            </el-table-column>

            <el-table-column
              prop="proxy_price"
              :label="item.t_name+'购买价'"
            >
            </el-table-column>

            <el-table-column
              prop="num"
              label="购买数量"
            >
            </el-table-column>

            <!-- <el-table-column
              prop="send_score"
              label="发货赠送积分"
            >
            </el-table-column> -->

            <el-table-column
              v-if="orderDetail.order_type == 1"
              prop="s_new_buy_num"
              label="发货赠送数量"
            >
            </el-table-column>



          </el-table>
        </div>
      </div>

    </div>

  </el-main>
</template>


<script>
import { bus } from "../../bus.js";
import API from "../../api/api_user";
export default {
  name: "orderDetail",
  created() {
    var orderId = this.$route.query.orderId;
    var special_type = this.$route.query.special_type;
    console.info(orderId);
    let that = this;
    that.subListVisible = true;
    that.subListLoading = true;
    let para = {
      token: localStorage.getItem("api_token"),
      id: orderId,
      specialType:special_type
    };
    API.good_order_detail(para)
      .then(
        function(result) {
          that.subListLoading = false;
          if (result && parseInt(result.key) === 1000) {
            that.orderDetail = result.result.map;
            if (that.orderDetail.free_type != null && (that.orderDetail.free_type == 3 || that.orderDetail.free_type == 2 || that.orderDetail.free_type == 7 || that.orderDetail.free_type == 9 || that.orderDetail.free_type == 5))
            {
              that.orderDetail.freeIn = '免费';
            } else {
              that.orderDetail.freeIn = '';
            }
            if (that.orderDetail.order_type == 1) {
              that.orderDetail.typeV = "自己提货发货";
            } else if (that.orderDetail.order_type == 2) {
              that.orderDetail.typeV = "购进";
            } else if (that.orderDetail.order_type == 3) {
              that.orderDetail.typeV = "补货";
            } else if (that.orderDetail.order_type == 4) {
              that.orderDetail.typeV = "补货大订单";
            }
            if(result.result.map.subPackage && result.result.map.subPackage.length > 0){
              var packageList = result.result.map.subPackage
              packageList.forEach(item => {
                if(item.sendGoodMsg){
                  item.sendGoodList = JSON.parse(item.sendGoodMsg)
                }else{
                  item.sendGoodList = []
                }
                if(item.noSendGoodMsg){
                  item.noSendGoodList = JSON.parse(item.noSendGoodMsg)
                }else{
                  item.noSendGoodList = []
                }
              })
            }
            that.subList = result.result.map.sub;
            if (result.result.map.orders != null) {
              that.buList = result.result.map.orders;
              for (var i = 0; i < that.buList.length; i++) {
                var initM = 0;
                var order_money = 0;
                for (var j = 0; j < that.buList[i].sub.length; j++) {
                  initM +=
                    that.buList[i].sub[j].down_price *
                    that.buList[i].sub[j].num;
                  order_money +=
                    that.buList[i].sub[j].proxy_price *
                    that.buList[i].sub[j].num
                }
                let b = Math.round(initM.toFixed(2) * 1000) / 1000
                that.buList[i].initM = b;
                let c = Math.round(order_money.toFixed(2) * 1000) / 1000
                that.buList[i].order_money = c;
              }
            } else {
              that.buList = [];
            }
          }
        },
        function(err) {
          that.subListLoading = false;
          that.$message.error({
            showClose: true,
            message: err.toString(),
            duration: 2000
          });
        }
      )
      .catch(function(error) {
        that.subListLoading = false;
        console.log(error);
        that.$message.error({
          showClose: true,
          message: "请求出现异常",
          duration: 2000
        });
      });
  },
  data() {
    return {
      subListVisible: false,
      orderDetail: {},
      addLoading: false,
      loading: false,
      goodName: null,
      goodId: null,
      dialogPics: [],
      dialogEditVisible: false,
      dialogContent: "",
      dialogTitle: "",
      subList: [],
      buList: [],
      subListLoading: false,
      dialogAddVisible: false,
      typeOptions: null,
      tableData: []
    };
  },
  mounted() {},
  methods: {
    objectSpanMethod({ row, rowIndex }) {
      return "table_head";
    }
  }
};
</script>

<style>
body {
  overflow: auto;
}
.fontWidth12 {
  width: 300px;
  display: inline-block;
  text-align: right;
}
.cont_navs_header1222 {
  background-color: #fff;
  width: 100%;
  height: 55px;
  box-sizing: border-box;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1);
  margin-bottom: 20px;
  padding-left: 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.table_head {
  background-color: #f8f8f8 !important;
  border-right: 1px solid #eee;
  border-bottom: 1px solid #eee;
  border-top: 1px solid #eee;
}

.main_content_detail {
  background-color: #f2f2f2;
}

.cont_navs {
  background-color: #fff;
  width: 100%;
  height: 55px;
  box-sizing: border-box;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1);
  text-align: center;
  margin-bottom: 20px;
}
.cont_navs li {
  display: inline-block;
  line-height: 21px;
  padding: 17px 0;
  margin: 0 20px;
  height: 55px;
  color: #bbb;
  font-size: 15px;
  text-align: center;
  cursor: pointer;
}
.cont_navs li:hover {
  color: #409eff;
}

.ac_li {
  color: #409eff;
  border-bottom: solid 2px #409eff;
}
.contain_div2222 {
}
.cont_btns1 {
  float: left;
  margin: 0px 0px 20px 0;
}
.contain_header {
  background-color: #fff;
  padding: 10px;
}
.cont_btns1 li {
  display: inline-block;
}

.contain_body {
  background-color: #fff;
  margin-top: 20px;
  position: relative;
  padding-bottom: 35px;
}
.contain_body_head {
  display: block;
  padding: 10px 0 10px 10px;
  font-size: 16px;
  margin-top: 10px;
  background-color: #f8f8f8;
}
.pageDiv {
  position: absolute;
  right: 0;
  bottom: 0;
}

.m-search {
  margin-bottom: -15px;
}
.el-button + .el-button {
  margin-left: 0px !important;
}

.pri-div {
  display: flex;
  width: 100%;
  justify-content: space-between;
}

.pri-div > div {
  width: 48%;
  border: 1px solid #dadada;
  border-radius: 10px;
  margin-bottom: 20px;
}
.guii-list {
  padding: 0 10px 10px 10px;
}
.guide-name {
  margin-top: 10px;
  margin-bottom: 10px;
}
.item-value span {
  background-color: #bbb;
  display: inline-block;
  width: 100px;
  padding: 5px 10px;
  cursor: pointer;
  margin-right: 10px;
  margin-top: 10px;
  text-align: center;
}

.guide-list > div {
  display: flex;
  justify-content: space-around;
  align-items: center;
}
.guide-list .el-input__inner {
  height: 27px;
  padding-right: 0px;
}
.guide-head {
  padding-top: 10px;
  background-color: #fafafa;
  border-top-right-radius: 10px;
  border-top-left-radius: 10px;
  margin-bottom: 10px;
}

.userInfooi {
  flex: 1;
  display: block;
  height: auto;
}

.moreUserInfo11 ul {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex-direction: row;
  flex-wrap: wrap;
  width: 100%;
}
.moreUserInfo11 li {
  color: #666;
  width: 33.3%;
}
.moreUserInfo11 .base_label {
  color: #000;
  font-size: 18px;
  font-weight: bold;
  margin: 15px 0;
}
.moreUserInfo11 ul li {
  line-height: 30px;
}
</style>



// WEBPACK FOOTER //
// src/components/good/orderDetail.vue